/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* Added by Jon N @ Shopify - May 13 2021  */
$(window).on('load', function() {
  var $announcementBarClose = $('.announcement-bar__close');
  var $announcementBarHeight = $('.announcement-bar--visible').height() || 0;
  var $searchBar = $('#search_bar');
  var $searchIcon = $('#search_button');
  var $headerBarHeight = $('.site-header-sections').outerHeight();
  var $restOfSite = $('.main-content, .drawer-cover, .navigation');

  function _openSearchBar() {
    $searchBar.css('top', '0').find('.input-group__field').focus();
    $searchBar.css('z-index', '999');
  }

  function _closeSearchBar() {
    $searchBar.css('top', -$headerBarHeight - 50);
    $restOfSite.off();
  }

  $searchBar.removeAttr('style').css({
    'top': -$headerBarHeight - 20,
    'height': $headerBarHeight,
    'margin-top': $announcementBarHeight
  });

  $searchIcon.on('click', function() {
    _openSearchBar();

    $restOfSite.on('click', function() {
      event.preventDefault();
      _closeSearchBar();
    })
  })

  $announcementBarClose.on('click', function() {
    $searchBar.css('margin-top', '');
  })
})

//Begin sticky header
var sections = window.theme.sections;
 
var headerExtension = {
  init: function() {
    this.on('section_load', this._promiseHeaderSlideIn.bind(this));
  },
 
  _promiseHeaderSlideIn: function() {
    //override original function
  }
};
 
sections.extend('header-section', headerExtension);
/* End of changes */

